import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedClass: '',
    selectedSubject: '',
    teacherId: null,
    classCode: '',
    classData: {},
};

export const teacherSubSlice = createSlice({
    name: 'teacher',
    initialState,
    reducers: {
        setClass: (state, action) => {
            state.selectedClass = action.payload;
        },
        setSubject: (state, action) => {
            state.selectedSubject = action.payload;
        },
        setteacherId: (state, action) => {
            state.teacherId = action.payload;
        },
        setClassCode: (state, action) => {
            state.classCode = action.payload;
        },
        setClassData: ( state, action ) => {
            state.classData = { ...action.payload};
            console.log("from reducer class data", state.classData)
        }
    },
});


export const { setClass, setSubject, setteacherId, setClassCode, setClassData } = teacherSubSlice.actions;

export default teacherSubSlice.reducer;
